<div *ngIf="isLoading" class="loader-bar"></div>
  
  <div mat-dialog-title *ngIf="!isLoading">
    <div class="payment-transfer-header">
      <div class="title">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="24" viewBox="0 0 20 32" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M1.1482 12.2525C-0.382732 10.7277 -0.382732 8.23471 1.1482 6.70988L6.75648 1.12341C8.26001 -0.37447 10.6782 -0.37447 12.1817 1.12341L12.2512 1.19283C13.7878 2.72339 13.8128 5.07484 12.1931 6.70886L6.71238 12.2525C5.17578 13.7831 2.6848 13.7831 1.1482 12.2525Z"
            fill="#00698F" />
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M7.90808 30.8187C6.34948 29.2441 6.34948 26.6903 7.90808 25.116L13.1872 19.7805C14.7458 18.2059 17.2727 18.2059 18.8313 19.7805C20.3896 21.3556 20.3896 23.909 18.8313 25.484L13.5518 30.8187C11.9935 32.3938 9.46635 32.3938 7.90808 30.8187Z"
            fill="#00698F" />
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M2.63945 23.42L2.62106 23.4014C1.05868 21.8229 1.05868 19.2633 2.62106 17.6845L11.7031 8.50678C13.2655 6.92795 15.7984 6.92795 17.3608 8.50678L17.3792 8.52536C18.9412 10.1042 18.9412 12.6635 17.3792 14.2423L8.29716 23.42C6.73478 24.9988 4.20182 24.9988 2.63945 23.42Z"
            fill="#00698F" />
        </svg>
        <div>Sentoo payment</div>
      </div>
      <button (click)="dialogRef.close()" class="btn btn-default">
        <i class="icon-close"></i>
      </button>
    </div>
  </div>

  <div mat-dialog-content class="validate-payment" *ngIf="!isLoading">
    <p class="font-weight-bold fs-18">
      Confirm your payment with the {{items.bankToken.fields.text.value}}
    </p>
    <div class="list-numbered">
      <ul class="list-numbered fixed-view order-steps-list">
        <li>
          <div>
            <div class="circle">
              <span>1</span>
            </div>
          </div>
          <div>
            <span>Press<span class="press"><i class="icon-caret-left"></i></span>to turn on the {{items.bankToken.fields.text.value}}</span>
          </div>
        </li>
        <li>
          <div>
            <div class="circle">
              <span>2</span>
            </div>
          </div>
          <div>
            <span>Enter your 4-digit PIN Code in the {{items.bankToken.fields.text.value}}</span>
          </div>
        </li>
        <li>
          <div>
            <div class="circle">
              <span>3</span>
            </div>
          </div>
          <div>
            <span>Press number "2"</span>
          </div>
        </li>
        <li>
          <div>
            <div class="circle">
              <span>4</span>
            </div>
          </div>
          <div>
            <span>Enter the following Security Code in the {{items.bankToken.fields.text.value}}: <span
                class="text-marine-blue font-weight-bold challenge-text"> {{ challengeCode }} </span></span>
          </div>
        </li>
        <li>
          <div>
            <div class="circle">
              <span>5</span>
            </div>
          </div>
          <div>
            <span>Press and hold until "2" is shown</span>
          </div>
        </li>
        <li>
          <div>
            <div class="circle">
              <span>6</span>
            </div>
          </div>
          <div>
            <span>Press<span class="press"><i class="icon-caret-left"></i></span>to generate the Transfer</span>
          </div>
        </li>
        <li>
          <div>
            <div class="circle">
              <span>7</span>
            </div>
          </div>
          <div>
            <span>Enter the generated Transfer Approval Code in the field below</span>
          </div>
        </li>
      </ul>
    </div>
    <form [formGroup]="confirmPaymentForm">
      <div class="form-group">
        <label>Transfer Approval Code
          <input class="form-control w-50" formControlName="approvalCode" maxlength="14" #approvalCodeInput />
          <span class="field-validation-error" *ngIf="approvalCode?.errors?.required">This field is required</span>
          <span class="field-validation-error" *ngIf="approvalCode?.errors?.pattern">Only numbers are allowed</span>
          <span class="field-validation-error" *ngIf="approvalCode?.errors?.approvalCodeError">{{approvalCodeErrorMessage}}</span>
        </label>
      </div>
    </form>
  </div>
  <div mat-dialog-actions *ngIf="!isLoading">
    <button class="btn btn-primary btn-block" (click)="submitPayment()" [disabled]="isSubmittingConfirm">Confirm transfer</button>
    <button class="btn btn-link btn-block" (click)="openCancelPaymentPopup()">Cancel</button>
  </div>
